import { HeroUIProvider, ToastProvider } from "@heroui/react";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import ReactDOM from "react-dom/client";

import { AuthProvider } from "@/core/auth/AuthProvider";
import { authAdapter } from "@/core/auth/adapter";
import { routeTree } from "./routeTree.gen";

import "./styles.css";
import UrqlProvider from "./providers/UrqlProvider";

export const router = createRouter({
	routeTree,
	context: { authAdapter },
	defaultPreload: "intent",
	scrollRestoration: true,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

// Prevent inadvertent number input increment/decrement when scrolling
document.addEventListener(
	"wheel",
	(event) => {
		if (
			event.target instanceof HTMLInputElement &&
			event.target.type === "number" &&
			document.activeElement === event.target
		) {
			event.target.blur();
		}
	},
	{ passive: true },
);

const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
	ReactDOM.createRoot(rootElement).render(
		<HeroUIProvider>
			<ToastProvider placement="top-right" />
			<UrqlProvider>
				<AuthProvider>
					<RouterProvider router={router} />
				</AuthProvider>
			</UrqlProvider>
		</HeroUIProvider>,
	);
}
